import React, { Component } from "react";
import PropTypes from "prop-types";
import { TYPE_CHECKBOXES } from "common/filter/constants";
import { getQueryFromValue } from "common/filter/utils";
import { getQueryFromValue as getPagerQueryFromValue } from "common/pager/utils";
import without from "lodash/without";

/**
 * Tag related to `TYPE_CHECKBOXES` filter.
 *
 * @author Nathan Ozelim <nathan@startupfoundry.com>
 */
export default class Tag extends Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
  }

  toggle() {
    const { tagValue, value, field, router, resourceName } = this.props;
    const newValue = value.includes(tagValue)
      ? without(value, tagValue)
      : value.concat(tagValue);
    const currentLocation = router.getCurrentLocation();
    const filterQuery = getQueryFromValue(
      resourceName,
      field,
      TYPE_CHECKBOXES,
      newValue
    );
    /* clear page when updating filter */
    const pagerQuery = getPagerQueryFromValue(resourceName, "");
    const updatedQuery = {
      ...currentLocation.query,
      ...filterQuery,
      ...pagerQuery,
    };

    /* update URL with new query parameters */
    router.push({
      ...currentLocation,
      query: updatedQuery,
    });
  }

  render() {
    const { tagLabel } = this.props;

    return (
      <span className="tag-filter tag tag-plain tag-sm" onClick={this.toggle}>
        {tagLabel}
      </span>
    );
  }
}

Tag.propTypes = {
  tagLabel: PropTypes.string.isRequired,
  tagValue: PropTypes.string.isRequired,
  value: PropTypes.array.isRequired,
  field: PropTypes.string.isRequired,
  resourceName: PropTypes.string.isRequired,
};
